import { render, staticRenderFns } from "./report_details.vue?vue&type=template&id=a6170d88&"
import script from "./report_details.vue?vue&type=script&lang=js&"
export * from "./report_details.vue?vue&type=script&lang=js&"
import style0 from "./report_details.vue?vue&type=style&index=0&id=a6170d88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports